import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { EddyAutoComplete, Licitacao, LicitacaoOrgaoAudesp, Login, OrgaoAudesp, OrgaoAudespService } from 'eddydata-lib';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';
import { LicitacaoOrgaoAudespService } from './service/licitacao-orgao-audesp.service';

@Component({
  selector: 'app-licitacao-orgao-audesp',
  templateUrl: './licitacao-orgao-audesp.component.html'
})
export class LicitacaoOrgaoAudespComponent implements OnInit, OnDestroy {

  public orgaoAudespAutoComplete: EddyAutoComplete<OrgaoAudesp>;
  public orgaoAtual: OrgaoAudesp;

  @Input() entidade: Licitacao;
  @Input() login: Login;

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected confirmationService: ConfirmationService,
    protected orgaoAudespService: OrgaoAudespService,
    protected licitacaoOrgaoAudespService: LicitacaoOrgaoAudespService,
  ) { }

  ngOnInit(): void {
    this.orgaoAudespAutoComplete = new EddyAutoComplete(null, this.orgaoAudespService, 'id', ['nome_municipio', 'nome_entidade'],
      { orderBy: 'nome_municipio,nome_entidade' }, { number: ['codigo_municipio', 'codigo_entidade'], text: ['nome_municipio', 'nome_entidade'] }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public adicionar(orgao?: OrgaoAudesp) {
    if (!orgao) orgao = this.orgaoAtual;
    if (orgao) {
      if (!this.entidade.orgao_audesp_aderente) {
        this.entidade.orgao_audesp_aderente = [];
      }

      if (this.entidade.orgao_audesp_aderente.find((f) => f.orgao_audesp.id === orgao.id)) {
        toastr.warning('Orgao Audesp já incluído nesta licitação!');
      } else {
        const item = new LicitacaoOrgaoAudesp()
        item.orgao_audesp = orgao;
        item.orgao_aderente = true;

        this.entidade.orgao_audesp_aderente.push(item);
      }
      orgao = undefined;
      this.orgaoAtual = undefined;
    }
  }

  public remover(item: LicitacaoOrgaoAudesp, index: number) {
    if (item.id) {
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja remover este órgão aderente? Se existirem itens de adesão vinculados, eles também serão removidos.',
        header: 'Exclusão',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Confirmar',
        rejectLabel: 'Cancelar',
        accept: () => {
          this.licitacaoOrgaoAudespService.remover(item.id).pipe(takeUntil(this.unsubscribe))
            .subscribe((res) => {
              toastr.info('Registro removido com sucesso!', 'Exclusão');
              this.entidade.orgao_audesp_aderente.splice(index, 1);
            }, (err) => toastr.error(err.error.payload));
        }
      });
    } else {
      this.entidade.orgao_audesp_aderente.splice(index, 1);
    }
  }

}
